// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2k-GJ","icon":"SortAdornment_icon__1Bl7l","up":"SortAdornment_up__2g4n0","down":"SortAdornment_down__2iq6V","active":"SortAdornment_active__3go9f"};